import script from "./search-result-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./search-result-icon.vue?vue&type=script&lang=ts&setup=true"

import "./search-result-icon.vue?vue&type=style&index=0&id=a40027c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40027c2"]])

export default __exports__